import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useOnSubmitModal = (formfield) => {
  const { t } = useTranslation('host-reschedule');
  const { onOpenModal } = useModal();

  const onOpenSubmitModal = (mutate) => {
    onOpenModal({
      width: 'calc(100vw - 24px)',
      maxWidth: 'calc(100vw - 24px)',
      isOpen: true,
      type: 'confirm',
      title: t('confirm_submit.title'),
      contentDescription: t('confirm_submit.description'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('common:yes_submit'),
      secondaryButtonText: t('common:close'),
      onClickPrimaryButton: () => {
        mutate(formfield);
      },
    });
  };

  return onOpenSubmitModal;
};

export default useOnSubmitModal;
